import { parse } from 'cookie';
import FeatureGates, { FeatureGateEnvironment } from '@atlaskit/feature-gate-js-client';
import { Identifiers, FrontendExperimentsResponse } from '@atlassian/feature-gate-node-client-bootstrapper';

import { getAtlassianUser, getEnvironment } from 'src/services/http/user';
import { getClientOptions, TARGET_APP } from 'src/utils/featureGate';
import { User } from 'src/types';

export type FeatureGatesBootstrapValues = FrontendExperimentsResponse & {
  identifiers: Identifiers;
  environment: FeatureGateEnvironment;
};

export const getAnalyticsAnonymousId = (): string =>
  decodeURIComponent(parse(document?.cookie)?.ajs_anonymous_id || '').replace(/['"]+/g, '');

export const initializeFeatureGatesClient = async (
  currentUser?: User,
  featureGatesBootstrapValues?: FeatureGatesBootstrapValues,
): Promise<void> => {
  if (featureGatesBootstrapValues) {
    return FeatureGates.initializeFromValues(
      {
        environment: featureGatesBootstrapValues.environment,
        targetApp: TARGET_APP,
        sdkKey: featureGatesBootstrapValues.clientSdkKey,
      },
      featureGatesBootstrapValues.identifiers,
      undefined,
      featureGatesBootstrapValues.experimentValues,
    );
  }

  const analyticsAnonymousId = getAnalyticsAnonymousId();
  const user = currentUser || (await getAtlassianUser());

  const identifiers: Identifiers = {
    analyticsAnonymousId,
    atlassianAccountId: user?.account_id,
  };

  return FeatureGates.initialize(getClientOptions(getEnvironment()), identifiers);
};
